// Country Portal — Routes Configuration
// Roles: Admin (India 28 / Non-India 13), Sub-admin (10), Finance (1), Panelist (8+profile)
// Per DX_Modules.xlsx specification

import DashboardPage from "views/Dashboard/Dashboard.js";
import {List} from "./Components/Redemptions/List";
import {ApproveRequests} from "./Components/Redemptions/ApproveRequests";
import {RewardsList} from "./Components/Rewards/RewardsList";
import UserProfile from "./views/UserProfile/UserProfile";
import ReferralsList from "./Components/Referrals/RefferalsList";
import { Countries } from "./Components/Countries/Countries";
import { States } from "./Components/States/States";
import { City } from "./Components/Cities/City";
import { RedemptionMode } from "./Components/RedemptionMode/RedemptionMode";
import { LabelsList } from "./Components/Labels/LabelsList";
import { MarketingLinksList } from "./Components/MarketingLinks/MarketingLinksList";
import { SecList } from "./Components/Sec/SecList";
import { ProfileManagement } from "./Components/ProfileManagement/ProfileManagement";
import { RegisteredOnly } from "./Components/Panelists/RegisteredOnly";
import { PeopleTwoTone, PictureInPicture, DeleteSweep, Dashboard, AccountCircle, ListAlt, Redeem, CardGiftcard, Group, Apps, Description, HowToReg, AirlineSeatFlat, Person, Cancel, DeleteForever, Category, Email, Message, Help as HelpIcon, Settings, LocalOffer, Public, LocationCity, LocationOn, Business, AccountBox, Label, Link, Security, Info, ShoppingCart, Flight, Favorite, Home, SportsEsports, Theaters, Work, Devices, SmokingRooms, DriveEta, Fastfood, NotificationImportant, WhatsApp, ConfirmationNumber, SupervisorAccount, Edit, Assessment } from "@material-ui/icons";
import { BasicProfileOnly } from "./Components/Panelists/BasicProfileOnly";
import { UnsubscribedPanelistOnly } from "./Components/Panelists/UnsubscribedPanelistsOnly";
import { DeletedPanelistsOnly } from "./Components/Panelists/DeletedPanelistsOnly";
import { ApprovedDeleteRequest } from "Components/Panelists/ApprovedDeleteRequest";
import { AllPanelists } from "./Components/Panelists/AllPanelists";
import PenalistDetails from "Components/Panelists/PenalistDetails";
import { NewsLetters } from "./Components/NewsLetters/NewsLetters";
import { Messages } from "./Components/Messages/Messages";
import { Help } from "./Components/Help/Help";
import { MessageForm } from "./Components/Messages/MessageForm";
import { PanelistSurveys } from "./Components/PanelistSurveys/PanelistsSurveys";
import { About } from "./Components/PanelistProfile/About";
import { PersonalFinance } from "./Components/PanelistProfile/FinancialFinance";
import { Shopping } from "./Components/PanelistProfile/Shoppings";
import { Travels } from "./Components/PanelistProfile/Travels";
import { HealthAndWellness } from "./Components/PanelistProfile/HealthAndWellness";
import { HouseHold } from "./Components/PanelistProfile/HouseHold";
import { LeisureActivity } from "./Components/PanelistProfile/LeisureAndActivity";
import { Medias } from "./Components/PanelistProfile/Media";
import { Professional } from "./Components/PanelistProfile/Professional";
import { Electronics } from "./Components/PanelistProfile/Electronics";
import { Smokers } from "./Components/PanelistProfile/Smokers";
import { Auto } from "./Components/PanelistProfile/Auto";
import { FoodAndBeverage } from "./Components/PanelistProfile/FoodAndBeverage";
import { CURRENCY_SYMBOL } from 'Helper/currency';
import { Profiles } from "./Components/PanelistProfile/Profiles";
import MyRequests from "Components/Requests/MyRequests";
import MyRewards from "./Components/Rewards/MyRewards";
import MyReferralsList from "./Components/Referrals/MyReferralsList";
import { MySettings } from "./Components/My Settings/MySettings";
import AdminDashboard from "./views/Dashboard/AdminDashboard";
import { Notification } from './Components/Notification/Notification';
import { InactivePanelists } from "./Components/Panelists/InactivePanelists";
import { WhatsappTemplates } from "./Components/Templates/WhatsappTemplates";
import { MoviesBanner } from "./Components/MoviesBanners/MoviesBanner";
import { UploadCoupon } from "Components/Upload/UploadCoupon";

// India vs non-India admin distinction
const country = process.env.REACT_APP_COUNTRY || 'india';
const isIndia = country === 'india';

// ========================
// INDIA ADMIN — 28 modules
// ========================
const indiaAdminRoutes = [
  // 1. Admin Dashboard
  {
    path: "/dashboard-admin",
    name: "Admin Dashboard",
    hindi: "व्यवस्थापक डैशबोर्ड",
    icon: Dashboard,
    component: AdminDashboard,
    layout: "/admin",
    type: 'admin'
  },
  // 2. Redemption Requests
  {
    path: "/redemption",
    name: "Redemption Request",
    hindi: "रिडेम्प्शन अनुरोध",
    icon: Redeem,
    component: List,
    layout: "/admin",
    type: 'admin'
  },
  // 3. Rewards
  {
    path: "/rewards",
    name: "Rewards",
    hindi: "पुरस्कार",
    icon: CardGiftcard,
    component: RewardsList,
    layout: "/admin",
    type: 'admin'
  },
  // 4. Referrals (India only)
  {
    path: "/referrals",
    name: "Referrals",
    hindi: "रेफरल",
    icon: Group,
    component: ReferralsList,
    layout: "/admin",
    type: 'admin'
  },
  // 5. All (panelists)
  {
    path: "/panelistDashboard",
    name: "All",
    hindi: "सभी",
    icon: Apps,
    component: AllPanelists,
    layout: "/admin",
    type: 'admin'
  },
  // Hidden: Panelist Details (not a sidebar item)
  {
    path: "/panelistDetails/:userId",
    name: "Details",
    hindi: "विवरण",
    icon: Description,
    component: PenalistDetails,
    layout: "/admin",
    type: 'admin',
    isVisible: false
  },
  // 6. Registered Only (India only)
  {
    path: "/registeredOnlyPanelists",
    name: "Registered Only",
    hindi: "केवल पंजीकृत",
    icon: HowToReg,
    component: RegisteredOnly,
    layout: "/admin",
    type: 'admin'
  },
  // 7. Inactive Panelists (India only)
  {
    path: "/inactivePanelists",
    name: "Inactive Panelists",
    hindi: "निष्क्रिय पैनलिस्ट्स",
    icon: AirlineSeatFlat,
    component: InactivePanelists,
    layout: "/admin",
    type: "admin"
  },
  // 8. Basic Profile Panelists (India only)
  {
    path: "/basicProfileOnly",
    name: "Basic Profile Only",
    hindi: "केवल आधारभूत प्रोफ़ाइल",
    icon: Person,
    component: BasicProfileOnly,
    layout: "/admin",
    type: 'admin'
  },
  // 9. Unsubscribed Request (India only)
  {
    path: "/unsubscribeRequests",
    name: "Unsubscribe Requests",
    hindi: "सदस्यता रद्द अनुरोध",
    icon: Cancel,
    component: UnsubscribedPanelistOnly,
    layout: "/admin",
    type: 'admin'
  },
  // 10. Delete Requests
  {
    path: "/deleteRequests",
    name: "Delete Requests",
    hindi: "हटाएँ अनुरोध",
    icon: DeleteForever,
    component: DeletedPanelistsOnly,
    layout: "/admin",
    type: 'admin'
  },
  // 11. Deleted Accounts (India only)
  {
    path: "/deletedAccounts",
    name: "Deleted Accounts",
    hindi: "हटाए गए खाते",
    icon: DeleteSweep,
    component: ApprovedDeleteRequest,
    layout: "/admin",
    type: 'admin'
  },
  // 12. Sweepstakes
  {
    path: "/Sweepstakes",
    name: "Sweepstakes",
    hindi: "साँझा पुरस्कार",
    icon: PictureInPicture,
    component: MoviesBanner,
    layout: "/admin",
    type: 'admin'
  },
  // 13. Newsletter
  {
    path: "/newsletters",
    name: "Newsletters",
    hindi: "समाचार पत्रिकाएँ",
    icon: Email,
    component: NewsLetters,
    layout: "/admin",
    type: 'admin'
  },
  // 14. Messages
  {
    path: "/messages",
    name: "Messages",
    hindi: "संदेश",
    icon: Message,
    component: Messages,
    layout: "/admin",
    type: 'admin'
  },
  // 15. Help (India only)
  {
    path: "/help",
    name: "Help",
    hindi: "सहायता",
    icon: HelpIcon,
    component: Help,
    layout: "/admin",
    type: 'admin'
  },
  // 16. Redemptions Mode (India only)
  {
    path: "/redemption-mode",
    name: "Redemption Mode",
    hindi: "रिडेम्प्शन मोड",
    icon: LocalOffer,
    component: RedemptionMode,
    layout: "/admin",
    type: 'admin'
  },
  // 17. Country (India only)
  {
    path: "/country",
    name: "Country",
    hindi: "देश",
    icon: Public,
    component: Countries,
    layout: "/admin",
    type: 'admin'
  },
  // 18. States (India only)
  {
    path: "/states",
    name: "States",
    hindi: "राज्य",
    icon: LocationCity,
    component: States,
    layout: "/admin",
    type: 'admin'
  },
  // 19. Cities (India only)
  {
    path: "/cities",
    name: "Cities",
    hindi: "शहर",
    icon: LocationOn,
    component: City,
    layout: "/admin",
    type: 'admin'
  },
  // 20. Profiles
  {
    path: "/profile-management",
    name: "Profiles",
    hindi: "प्रोफ़ाइल्स",
    icon: AccountBox,
    component: ProfileManagement,
    layout: "/admin",
    type: 'admin'
  },
  // 21. Labels (India only)
  {
    path: "/labels",
    name: "Labels",
    hindi: "लेबल",
    icon: Label,
    component: LabelsList,
    layout: "/admin",
    type: 'admin'
  },
  // 22. Marketing Links (India only)
  {
    path: "/marketing-links",
    name: "Marketing Links",
    hindi: "मार्केटिंग लिंक्स",
    icon: Link,
    component: MarketingLinksList,
    layout: "/admin",
    type: 'admin'
  },
  // 23. SEC (India only)
  {
    path: "/SEC",
    name: "SEC",
    hindi: "सुरक्षा",
    icon: Security,
    component: SecList,
    layout: "/admin",
    type: 'admin'
  },
  // 24. WhatsApp Templates
  {
    path: "/whatsappTemplates",
    name: "Whatsapp Templates",
    hindi: "व्हाट्सएप टेम्पलेट्स",
    icon: WhatsApp,
    component: WhatsappTemplates,
    layout: "/admin",
    type: "admin"
  },
  // 25. Partnership
  {
    path: "/partnership",
    name: "Partnership",
    hindi: "साझेदारी",
    icon: ConfirmationNumber,
    component: UploadCoupon,
    layout: "/admin",
    type: 'admin'
  },
  // 26. Access Control for All → AllPanelists (user listing with roles)
  // TODO: AllPanelists is the closest user-listing component; ideally needs admin user management UI
  {
    path: "/access-control",
    name: "Access Control for All",
    hindi: "सभी के लिए एक्सेस नियंत्रण",
    icon: SupervisorAccount,
    component: AllPanelists,
    layout: "/admin",
    type: 'admin'
  },
  // 27. Access to Update User Details → PenalistDetails (user detail view with edit capability)
  // TODO: PenalistDetails shows user profile detail — closest match for updating user details
  {
    path: "/update-user-details",
    name: "Access to Update User Details",
    hindi: "उपयोगकर्ता विवरण अपडेट",
    icon: Edit,
    component: PenalistDetails,
    layout: "/admin",
    type: 'admin'
  },
  // 28. Reports Page → AdminDashboard (same component as dashboard — matches monolith & admin panel pattern)
  {
    path: "/reports",
    name: "Reports Page",
    hindi: "रिपोर्ट पृष्ठ",
    icon: Assessment,
    component: AdminDashboard,
    layout: "/admin",
    type: 'admin'
  },
  // Utility: User Profile (hidden from sidebar)
  {
    path: "/profile",
    name: "User Profile",
    hindi: "उपयोगकर्ता प्रोफ़ाइल",
    icon: AccountCircle,
    component: UserProfile,
    layout: "/admin",
    type: 'admin',
    isVisible: false
  },
];

// ========================
// NON-INDIA ADMIN — 13 modules
// (No Admin Dashboard, no India-specific modules)
// ========================
const nonIndiaAdminRoutes = [
  // 1. Partnership
  {
    path: "/partnership",
    name: "Partnership",
    hindi: "साझेदारी",
    icon: ConfirmationNumber,
    component: UploadCoupon,
    layout: "/admin",
    type: 'admin'
  },
  // 2. Redemption Requests
  {
    path: "/redemption",
    name: "Redemption Request",
    hindi: "रिडेम्प्शन अनुरोध",
    icon: Redeem,
    component: List,
    layout: "/admin",
    type: 'admin'
  },
  // 3. Rewards
  {
    path: "/rewards",
    name: "Rewards",
    hindi: "पुरस्कार",
    icon: CardGiftcard,
    component: RewardsList,
    layout: "/admin",
    type: 'admin'
  },
  // 4. All (panelists)
  {
    path: "/panelistDashboard",
    name: "All",
    hindi: "सभी",
    icon: Apps,
    component: AllPanelists,
    layout: "/admin",
    type: 'admin'
  },
  // Hidden: Panelist Details
  {
    path: "/panelistDetails/:userId",
    name: "Details",
    hindi: "विवरण",
    icon: Description,
    component: PenalistDetails,
    layout: "/admin",
    type: 'admin',
    isVisible: false
  },
  // 5. Newsletter
  {
    path: "/newsletters",
    name: "Newsletters",
    hindi: "समाचार पत्रिकाएँ",
    icon: Email,
    component: NewsLetters,
    layout: "/admin",
    type: 'admin'
  },
  // 6. Messages
  {
    path: "/messages",
    name: "Messages",
    hindi: "संदेश",
    icon: Message,
    component: Messages,
    layout: "/admin",
    type: 'admin'
  },
  // 7. Profiles
  {
    path: "/profile-management",
    name: "Profiles",
    hindi: "प्रोफ़ाइल्स",
    icon: AccountBox,
    component: ProfileManagement,
    layout: "/admin",
    type: 'admin'
  },
  // 8. Delete Requests
  {
    path: "/deleteRequests",
    name: "Delete Requests",
    hindi: "हटाएँ अनुरोध",
    icon: DeleteForever,
    component: DeletedPanelistsOnly,
    layout: "/admin",
    type: 'admin'
  },
  // 9. Sweepstakes
  {
    path: "/Sweepstakes",
    name: "Sweepstakes",
    hindi: "साँझा पुरस्कार",
    icon: PictureInPicture,
    component: MoviesBanner,
    layout: "/admin",
    type: 'admin'
  },
  // 10. WhatsApp Templates
  {
    path: "/whatsappTemplates",
    name: "Whatsapp Templates",
    hindi: "व्हाट्सएप टेम्पलेट्स",
    icon: WhatsApp,
    component: WhatsappTemplates,
    layout: "/admin",
    type: "admin"
  },
  // 11. Access Control for All → AllPanelists (user listing with roles)
  // TODO: AllPanelists is the closest user-listing component; ideally needs admin user management UI
  {
    path: "/access-control",
    name: "Access Control for All",
    hindi: "सभी के लिए एक्सेस नियंत्रण",
    icon: SupervisorAccount,
    component: AllPanelists,
    layout: "/admin",
    type: 'admin'
  },
  // 12. Access to Update User Details → PenalistDetails (user detail view with edit capability)
  // TODO: PenalistDetails shows user profile detail — closest match for updating user details
  {
    path: "/update-user-details",
    name: "Access to Update User Details",
    hindi: "उपयोगकर्ता विवरण अपडेट",
    icon: Edit,
    component: PenalistDetails,
    layout: "/admin",
    type: 'admin'
  },
  // 13. Reports Page → AdminDashboard (admin analytics/reports view)
  {
    path: "/reports",
    name: "Reports Page",
    hindi: "रिपोर्ट पृष्ठ",
    icon: Assessment,
    component: AdminDashboard,
    layout: "/admin",
    type: 'admin'
  },
  // Utility: User Profile (hidden from sidebar)
  {
    path: "/profile",
    name: "User Profile",
    hindi: "उपयोगकर्ता प्रोफ़ाइल",
    icon: AccountCircle,
    component: UserProfile,
    layout: "/admin",
    type: 'admin',
    isVisible: false
  },
];

// Build admin routes based on country
const adminRoutes = isIndia ? indiaAdminRoutes : nonIndiaAdminRoutes;

const dashboardRoutes = [
  // ========================
  // ADMIN routes — Country Portal (India or non-India based on REACT_APP_COUNTRY)
  // ========================
  ...adminRoutes,

  // ========================
  // PANELIST routes — all countries (8 modules + profile sub-pages, UNCHANGED)
  // ========================
  {
    path: "/dashboard",
    name: "Dashboard",
    hindi: "डैशबोर्ड",
    jp: "ダッシュボード ",
    icon: Dashboard,
    component: DashboardPage,
    layout: "/panelist",
    type: 'panelist'
  },
  {
    path: "/profile",
    name: "User Profile",
    hindi: "उपयोगकर्ता प्रोफ़ाइल",
    jp: "ユーザープロフィール ",
    icon: AccountBox,
    component: UserProfile,
    layout: "/panelist",
    type: 'panelist'
  },
  {
    path: "/my-rewards",
    name: "My Rewards",
    hindi: "मेरे पुरस्कार",
    jp: "マイリワード ",
    icon: CardGiftcard,
    component: MyRewards,
    layout: "/panelist",
    type: 'panelist'
  },
  {
    path: "/my-requests",
    name: "My Requests",
    hindi: "मेरे अनुरोध",
    jp: "マイリクエスト ",
    icon: Redeem,
    component: MyRequests,
    layout: "/panelist",
    type: 'panelist'
  },
  {
    path: "/my-referrals",
    name: "My Referrals",
    hindi: "मेरे रेफरल",
    jp: "マイ紹介 ",
    icon: Group,
    component: MyReferralsList,
    layout: "/panelist",
    type: 'panelist'
  },
  {
    path: "/panelist-surveys",
    name: "My Surveys",
    hindi: "मेरे सर्वे",
    jp: "マイアンケート ",
    icon: ListAlt,
    component: PanelistSurveys,
    layout: "/panelist",
    type: 'panelist'
  },
  {
    path: "/settings",
    name: "My Settings",
    hindi: "मेरी सेटिंग्स",
    jp: "設定 ",
    icon: Settings,
    component: MySettings,
    layout: "/panelist",
    type: 'panelist'
  },
  {
    path: "/panelist-message",
    name: "Contact Us",
    hindi: "हमसे संपर्क करें",
    jp: "お問い合わせ ",
    icon: Message,
    component: MessageForm,
    layout: "/panelist",
    type: 'panelist'
  },
  {
    path: "/profile-overview",
    name: "PROFILE",
    hindi: "प्रोफ़ाइल",
    jp: "マイプロフィール ",
    icon: AccountBox,
    component: Profiles,
    layout: "/panelist",
    type: 'panelist'
  },
  {
    path: "/about",
    name: "About",
    hindi: "बारे में",
    jp: "アバウト ",
    icon: Info,
    component: About,
    layout: "/panelist",
    type: 'panelist'
  },
  {
    path: "/personal-finance",
    name: "Personal Finance",
    hindi: "व्यक्तिगत वित्त",
    jp: "個人金融 ",
    icon: CURRENCY_SYMBOL,
    component: PersonalFinance,
    layout: "/panelist",
    type: 'panelist'
  },
  {
    path: "/shopping",
    name: "Shopping",
    hindi: "खरीदारी",
    jp: "ショッピング ",
    icon: ShoppingCart,
    component: Shopping,
    layout: "/panelist",
    type: 'panelist'
  },
  {
    path: "/travels",
    name: "Travel",
    hindi: "यात्रा",
    jp: "旅行 ",
    icon: Flight,
    component: Travels,
    layout: "/panelist",
    type: 'panelist'
  },
  {
    path: "/health-wellness",
    name: "Health And Wellness",
    hindi: "स्वास्थ्य और बेहतरीनी",
    jp: "健康とウェルネス ",
    icon: Favorite,
    component: HealthAndWellness,
    layout: "/panelist",
    type: 'panelist'
  },
  {
    path: "/household",
    name: "House Hold",
    hindi: "परिवार",
    jp: "世帯 ",
    icon: Home,
    component: HouseHold,
    layout: "/panelist",
    type: 'panelist'
  },
  {
    path: "/Leisure-activity",
    name: "Leisure And Activity",
    hindi: "फुर्सत और गतिविधि",
    jp: "レジャーと活動 ",
    icon: SportsEsports,
    component: LeisureActivity,
    layout: "/panelist",
    type: 'panelist'
  },
  {
    path: "/media",
    name: "Media",
    hindi: "मीडिया",
    jp: "メディア ",
    icon: Theaters,
    component: Medias,
    layout: "/panelist",
    type: 'panelist'
  },
  {
    path: "/professionals",
    name: "Professional",
    hindi: "पेशेवर",
    jp: "プロフェッショナル ",
    icon: Work,
    component: Professional,
    layout: "/panelist",
    type: 'panelist'
  },
  {
    path: "/electronics",
    name: "Electronics",
    hindi: "इलेक्ट्रॉनिक्स",
    jp: "電子機器 ",
    icon: Devices,
    component: Electronics,
    layout: "/panelist",
    type: 'panelist'
  },
  {
    path: "/smokers",
    name: "Smokers",
    hindi: "धूम्रपानकर्ता",
    jp: "喫煙 ",
    icon: SmokingRooms,
    component: Smokers,
    layout: "/panelist",
    type: 'panelist'
  },
  {
    path: "/auto",
    name: "Auto",
    hindi: "ऑटो",
    jp: "自動車 ",
    icon: DriveEta,
    component: Auto,
    layout: "/panelist",
    type: 'panelist'
  },
  {
    path: "/food-beverage",
    name: "Food And Beverage",
    hindi: "खाद्य और पेय",
    jp: "食品と飲料 ",
    icon: Fastfood,
    component: FoodAndBeverage,
    layout: "/panelist",
    type: 'panelist'
  },
  {
    path: "/Notifications",
    name: "Inbox",
    hindi: "इनबॉक्स",
    jp: "受信トレイ ",
    icon: NotificationImportant,
    component: Notification,
    layout: "/panelist",
    type: 'panelist',
    isVisible: false
  },

  // ========================
  // SUB-ADMIN — Exactly 10 modules
  // ========================
  // 1. Partnership
  {
    path: "/partnership",
    name: "Partnership",
    hindi: "साझेदारी",
    icon: ConfirmationNumber,
    component: UploadCoupon,
    layout: "/sub-admin",
    type: 'sub-admin'
  },
  // 2. Redemption Requests
  {
    path: "/redemption",
    name: "Redemption Request",
    hindi: "रिडेम्प्शन अनुरोध",
    icon: Redeem,
    component: List,
    layout: "/sub-admin",
    type: 'sub-admin'
  },
  // 3. Rewards
  {
    path: "/rewards",
    name: "Rewards",
    hindi: "पुरस्कार",
    icon: CardGiftcard,
    component: RewardsList,
    layout: "/sub-admin",
    type: 'sub-admin'
  },
  // 4. All (panelists)
  {
    path: "/panelistDashboard",
    name: "All",
    hindi: "सभी",
    icon: Apps,
    component: AllPanelists,
    layout: "/sub-admin",
    type: 'sub-admin'
  },
  // Hidden: Panelist Details
  {
    path: "/panelistDetails/:userId",
    name: "Details",
    hindi: "विवरण",
    icon: Description,
    component: PenalistDetails,
    layout: "/sub-admin",
    type: 'sub-admin',
    isVisible: false
  },
  // 5. Newsletter
  {
    path: "/newsletters",
    name: "Newsletters",
    hindi: "समाचार पत्रिकाएँ",
    icon: Email,
    component: NewsLetters,
    layout: "/sub-admin",
    type: 'sub-admin'
  },
  // 6. Messages
  {
    path: "/messages",
    name: "Messages",
    hindi: "संदेश",
    icon: Message,
    component: Messages,
    layout: "/sub-admin",
    type: 'sub-admin'
  },
  // 7. Profiles
  {
    path: "/profile-management",
    name: "Profiles",
    hindi: "प्रोफ़ाइल्स",
    icon: AccountBox,
    component: ProfileManagement,
    layout: "/sub-admin",
    type: 'sub-admin'
  },
  // 8. Delete Requests
  {
    path: "/deleteRequests",
    name: "Delete Requests",
    hindi: "हटाएँ अनुरोध",
    icon: DeleteForever,
    component: DeletedPanelistsOnly,
    layout: "/sub-admin",
    type: 'sub-admin'
  },
  // 9. Sweepstakes
  {
    path: "/Sweepstakes",
    name: "Sweepstakes",
    hindi: "साँझा पुरस्कार",
    icon: PictureInPicture,
    component: MoviesBanner,
    layout: "/sub-admin",
    type: 'sub-admin'
  },
  // 10. WhatsApp Templates
  {
    path: "/whatsappTemplates",
    name: "Whatsapp Templates",
    hindi: "व्हाट्सएप टेम्पलेट्स",
    icon: WhatsApp,
    component: WhatsappTemplates,
    layout: "/sub-admin",
    type: "sub-admin"
  },
  // Utility: User Profile (hidden from sidebar)
  {
    path: "/profile",
    name: "User Profile",
    hindi: "उपयोगकर्ता प्रोफ़ाइल",
    icon: AccountCircle,
    component: UserProfile,
    layout: "/sub-admin",
    type: 'sub-admin',
    isVisible: false
  },

  // ========================
  // FINANCE — Exactly 1 module (per DX_Modules.xlsx)
  // ========================
  // 1. Approve Requests
  {
    path: "/approveRedeemptionRequests",
    name: "Approve Requests",
    hindi: "अनुरोध मंजूरी",
    icon: Redeem,
    component: ApproveRequests,
    layout: "/finance",
    type: "finance"
  },
  // Utility: User Profile (hidden from sidebar)
  {
    path: "/profile",
    name: "User Profile",
    hindi: "उपयोगकर्ता प्रोफ़ाइल",
    icon: AccountCircle,
    component: UserProfile,
    layout: "/finance",
    type: 'finance',
    isVisible: false
  },
];

export default dashboardRoutes;
